import type { CardIconKey } from '@chillout/ui'

export interface CardIconGroup {
  labelKey: string
  icons: CardIconKey[]
}

export const CARD_ICON_GROUPS: CardIconGroup[] = [
  {
    labelKey: 'loyalty.iconPicker.drinks',
    icons: ['Coffee', 'CupSoda', 'Milk', 'Martini', 'Wine', 'Beer'],
  },
  {
    labelKey: 'loyalty.iconPicker.food',
    icons: ['Hamburger', 'Beef', 'Ham', 'Fish', 'Pizza', 'Drumstick', 'Popcorn', 'Sandwich', 'Croissant', 'Broccoli', 'CookingPot', 'ChefHat', 'Utensils', 'Salad', 'Soup'],
  },
  {
    labelKey: 'loyalty.iconPicker.sweets',
    icons: ['Cookie', 'Cake', 'CakeSlice', 'Donut', 'IceCreamCone', 'Popsicle', 'Candy', 'Lollipop'],
  },
  {
    labelKey: 'loyalty.iconPicker.reward',
    icons: ['Gift', 'Star', 'Heart', 'Sparkles', 'Trophy', 'Crown', 'Flame'],
  },
]